<template>
  <b-card no-body v-if="order" class="cp__order" :class="{'cp__order__detail': enableColumnLayout, 'cp__order__history': isCustomerPortalOrderHistory}">
    <b-card-header v-if="showHeader" class="d-flex align-items-center justify-content-between align-items-center">
      <div class="top-container d-flex align-items-center">
        <span class="top-container-text order_number">#{{order['order_id']}}</span>
        <span class="top-container-text order_date"><span class="separator">|</span> {{getShortHumanReadableDate(order['created'])}}</span>
        <template v-if="canShowPaymentStatus">
          <div class="separator">|</div>
          <span class="badge order-status payment_status" :class="getPaymentStatusClass(order)">{{getPaymentStatus(order)}}</span>
        </template>
      </div>
      <div class="d-none d-xl-flex cp__order__right__container" v-if="canShowTransactions">
        <span v-if="canShowTransactions" class="cp__order__right__container__text" @click.stop="toggleTransactionDialog()" >
          View Transactions
        </span>
      </div>
      <div class="d-flex d-xl-none cp__order__right__container mb" v-if="canShowTransactions">
        <div @click.stop="showHeaderDropdown = !showHeaderDropdown"><img :src="require('@/assets/images/menu.svg')"  alt=""/></div>
        <div class="cp__order__right__container__dropdown" :class="{'d-none': !showHeaderDropdown}" v-click-outside="onClickOutside">
          <span class="cp__order__right__container__text" v-if="canShowTransactions" @click.stop="toggleTransactionDialog()">
            View Transactions
          </span>
        </div>
      </div>
    </b-card-header>
    <b-card-body class="cp__order__items" :class="{'flex-column p-0': enableColumnLayout}">
      <div v-if="!orderAgain" class="cp__order__items__info top hide-sm" :class="{'pl-0': isCustomerPortalOrderList}">
        <p class="cp__order__items__info__text mb-0">
          <span>Order Placed:</span>
          <span class="ml-2 bold__text">{{getShortHumanReadableDate(order['created'])}}</span>
        </p>
      </div>
      <div class="cp__order__item" :class="{
        'w-100': order['items'].length === 1 || enableColumnLayout,
        'mr-0 mb-0': enableColumnLayout
      }" v-for="(item, index) in order['items']" v-bind:key="'order-item-' + (index + 1)">
        <template v-if="isOrderDetail">
          <div class="cp__order__item__info top pl-0">
            <div :class="{'d-flex d-lg-none': isOrderDetail}">
              <p class="cp__order__item__info__text" v-if="isTrial(item)">
                <span class="mr-2">On Trial</span>
                <span v-if="isRecurring(item) && !isCustomerPortalOrderHistory" class="badge order-status" :class="getItemStatusClass(item)">
                  {{getItemStatus(item)}}
                </span>
              </p>
              <p v-else-if="canShowSubscriptionStatus" class="cp__order__item__info__text">
                <template v-if="isRecurring(item)">
                  <span class="mr-2">Subscription</span>
                  <span v-if="!isCustomerPortalOrderHistory" class="badge order-status" :class="getItemStatusClass(item)">
                    {{getItemStatus(item)}}
                  </span>
                </template>
                <span v-else>
                  <span>One-time Order</span>
                  <span v-if="isCustomerPortalOrderHistory && !isItemStatusActive(item)" class="ml-2 badge order-status" :class="getItemStatusClass(item)">
                    {{getItemStatus(item)}}
                  </span>
                </span>
              </p>
            </div>
          </div>
        </template>
        <div class="cp__order__item__content">
          <div class="d-flex w-100" :class="{'align-self-start': item.showActions}">
            <div class="cp__order__item__image" :class="{'unset': isOrderDetail, 'mb-0': !isOrderDetail && !isCustomerPortalOrderHistory,
             'order-history-img': isCustomerPortalOrderHistory}">
              <img :src="getItemImageUrl(item)" @error="setAltImg($event, item)" alt="" />
            </div>
            <div class="cp__order__item__info">
              <p class="cp__order__item__info__name" :class="{'text-ellipses order_detail': isOrderDetail}" v-html="item.name"></p>
              <p class="cp__order__item__info__text " v-if="isTrial(item)" :class="{'d-none d-lg-flex': isOrderDetail}">
                <span class="mr-2">On Trial</span>
                <span class="badge order-status active">Active</span>
              </p>
              <p v-else-if="canShowSubscriptionStatus" class="cp__order__item__info__text" :class="{'d-none d-lg-flex': isOrderDetail}">
                <template v-if="isRecurring(item)">
                  <span class="mr-2">Subscription</span>
                  <span class="badge order-status" :class="getItemStatusClass(item)">
                    {{getItemStatus(item)}}
                  </span>
                </template>
                <span v-else>
                  <span>One-time Order</span>
                  <span v-if="isCustomerPortalOrderHistory && !isItemStatusActive(item)" class="ml-2 badge order-status" :class="getItemStatusClass(item)">
                    {{getItemStatus(item)}}
                  </span>
                </span>
              </p>
              <p class="cp__order__item__info__text" v-if="canShowPrice">
                {{item.quantity}} x {{item.price | currency(order.currency)}}
              </p>
              <template v-if="canShowNextBillDate && item.campaign_product.show_next_bill_price && isOrderDetail">
                <template v-if="isSubscriptionActive(item)">
                  <p v-if="item.next_bill_date" class="cp__order__item__info__text">
                    <span>Next Shipment:</span>
                    <span class="ml-2 bold__text">{{getShortHumanReadableUTCDate(item.next_bill_date)}}</span>
                  </p>
                  <p v-if="isSubscriptionPauseScheduled(item)" class="cp__order__item__info__text">
                    Paused until {{getShortHumanReadableUTCDate(item.pause_resume_date)}}
                  </p>
                </template>
                <p v-else-if="isSubscriptionCancelScheduled(item)" class="cp__order__item__info__text">
                  Cancel on {{getShortHumanReadableUTCDate(item.cancel_date)}}
                </p>
              </template>
              <p class="cp__order__item__info__text " v-if="showFulfillment(item)">
                <span class="mr-2">Shipment</span>
                <span class="badge order-status" :class="getItemFulfillmentStatusClass(item)">
                  {{getItemFulfillmentStatus(item)}}
                </span>
              </p>
            </div>
          </div>
          <div class="cp__order__item__inputs" v-if="isOrderDetail && ((item['actions'] && item['actions'].length) || item.can_track_shipment)">
            <b-button v-for="(action, index) in item['actions']" v-bind:key="'action-btn-'+action"
                      class="btn-outline-success" variant="secondary" @click="selectItemInput(item, action)"
                      :class="{'d-none': !item.showActions && item['actions'].length > 3 && index > 2}"
            >
              <span>{{getIntentLabel(item, action)}}</span>
            </b-button>
            <b-button v-if="item.can_track_shipment" class="btn-outline-success" variant="secondary" @click="toggleShipments(item)">
              <span>Track Shipment</span>
            </b-button>
            <div v-if="item['actions'].length > 3" class="more-options" @click.stop="toggleItemActionsDropdown(index)">
              <hr class="more-options-separator d-block d-lg-none" />
              <span><template v-if="item.showActions">Hide</template><template v-else>Show</template> More Options</span>
              <svg v-if="item.showActions" xmlns="http://www.w3.org/2000/svg" width="13" height="8" viewBox="0 0 13 8" fill="none">
                <path d="M11.5 6.5L6.5 1.5L1.5 6.5" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <svg v-else xmlns="http://www.w3.org/2000/svg" width="13" height="8" viewBox="0 0 13 8" fill="none">
                <path d="M1.5 1.5L6.5 6.5L11.5 1.5" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
          </div>
          <div class="cp__order__item__inputs" v-else-if="isCustomerPortalOrderHistory">
            <b-button v-if="canReactivateSubscription(item)" class="cp__order__btn no-outline-btn" variant="secondary" @click.stop="toggleCheckout([item], true, true)">
              <span>Re-Activate</span>
            </b-button>
            <b-button v-if="canBuyAgain(item)" class="cp__order__btn no-outline-btn" variant="secondary" @click.stop="toggleCheckout([item], false, true)">
              <span v-if="isRecurring(item)">Buy One-Time</span>
              <span v-else>Re-Order</span>
            </b-button>
          </div>
        </div>
        <hr v-if="(isOrderDetail && index !== (order['items'].length - 1)) || isCustomerPortalOrderHistory" />
      </div>
    </b-card-body>
    <b-card-footer footer-bg-variant="transparent" v-if="showFooter">
      <template v-if="isOrderDetail">
        <div class="d-flex flex-column my-1 mt-3">
          <div class="d-flex justify-content-between align-items-center">
            <p class="cp__order__text">Subtotal</p>
            <p class="cp__order__value">{{order.subtotal | currency(order.currency)}}</p>
          </div>
          <div class="d-flex justify-content-between align-items-center" v-if="canShowShippingPrice">
            <p class="cp__order__text">Shipping</p>
            <p class="cp__order__value">{{order.shipping_price | currency(order.currency)}}</p>
          </div>
          <div class="d-flex justify-content-between align-items-center" v-if="showHiddenFees">
            <p class="cp__order__text">{{campaign.portal_settings.hidden_fees_label || session.hidden_fees_label}}</p>
            <p class="cp__order__value">{{order.hidden_fees | currency(order.currency)}}</p>
          </div>
          <div class="d-flex justify-content-between align-items-center" v-if="showDiscount">
            <p class="cp__order__text">Discount</p>
            <p class="cp__order__value cancelled">-{{order.discount | currency(order.currency)}}</p>
          </div>
          <div class="d-flex justify-content-between align-items-center" v-if="canShowTaxes">
            <p class="cp__order__text">Taxes</p>
            <p class="cp__order__value">{{order.tax | currency(order.currency)}}</p>
          </div>
          <div class="d-flex justify-content-between align-items-center" v-if="showTip">
            <p class="cp__order__text">Tip</p>
            <p class="cp__order__value">{{order.tip | currency(order.currency)}}</p>
          </div>
          <div class="d-flex justify-content-between align-items-center">
            <p class="cp__order__text cp__order__total mb-0">Order Total</p>
            <p class="cp__order__value cp__order__total mb-0">{{order.total_discounted_price | currency(order.currency)}}</p>
          </div>
          <template v-if="showOrderSummary">
            <hr class="order-summary-separator" />
            <div class="d-flex justify-content-between align-items-center" v-if="showPastBalance">
              <p class="cp__order__text">Past Payments</p>
              <p class="cp__order__value">{{order.past_balance | currency(order.currency)}}</p>
            </div>
            <div class="d-flex justify-content-between align-items-center" v-if="showForwardBalance">
              <p class="cp__order__text">Carry Forward</p>
              <p class="cp__order__value cancelled">-{{order.forward_balance | currency(order.currency)}}</p>
            </div>
            <div class="d-flex justify-content-between align-items-center" v-if="showVoid">
              <p class="cp__order__text">Voided</p>
              <p class="cp__order__value cancelled">-{{order.amount_voided | currency(order.currency)}}</p>
            </div>
            <div class="d-flex justify-content-between align-items-center" v-if="showRefund">
              <p class="cp__order__text">Refunded</p>
              <p class="cp__order__value cancelled">-{{order.settled_refund_amount | currency(order.currency)}}</p>
            </div>
            <div class="d-flex justify-content-between align-items-center" v-if="showPendingRefund">
              <p class="cp__order__text">
                <b-tooltip target="help" triggers="hover" placement="top">
                  The refund is pending because the payment has not been captured yet.<br/>
                  We will be able to process the refund once the charge is captured.<br/>
                  This may take a few business days to appear.<br/>
                </b-tooltip>
                Pending Refund <img id="help" :src="require('@/assets/images/help.svg')"/>
              </p>
              <p class="cp__order__value pending">-{{order.pending_refund_amount | currency(order.currency)}}</p>
            </div>
            <div class="d-flex justify-content-between align-items-center" v-if="showStoreCredit">
              <p class="cp__order__text">Store Credit</p>
              <p class="cp__order__value cancelled">-{{order.store_credit | currency(order.currency)}}</p>
            </div>
            <div class="d-flex justify-content-between align-items-center" v-if="showChargeback">
              <p class="cp__order__text">Chargeback</p>
              <p class="cp__order__value cancelled">-{{order.chargeback_amount | currency(order.currency)}}</p>
            </div>
            <div class="d-flex justify-content-between align-items-center" v-if="showAmountDue">
              <p class="cp__order__text">Amount Due</p>
              <p class="cp__order__value">{{order.amount_due | currency(order.currency)}}</p>
            </div>
            <div class="d-flex justify-content-between align-items-center">
              <p class="cp__order__text cp__order__total mb-0">Total Paid</p>
              <p class="cp__order__value cp__order__total mb-0">{{order.total_remaining_balance | currency(order.currency)}}</p>
            </div>
          </template>
          <template v-if="canShowToggleSummary">
            <hr class="order-summary-separator" />
            <div class="order-summary-btn" @click.stop="toggleOrderSummary()">
              <span><template v-if="showOrderSummary">Hide</template><template v-else>Show</template> Order Summary</span>
              <svg v-if="showOrderSummary" xmlns="http://www.w3.org/2000/svg" width="13" height="8" viewBox="0 0 13 8" fill="none">
                <path d="M11.5 6.5L6.5 1.5L1.5 6.5" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <svg v-else xmlns="http://www.w3.org/2000/svg" width="13" height="8" viewBox="0 0 13 8" fill="none">
                <path d="M1.5 1.5L6.5 6.5L11.5 1.5" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
          </template>
        </div>
      </template>
      <template v-else>
        <b-button v-if="orderAgain" class="cp__order__btn no-outline-btn order-footer-btn" @click.stop="toggleCheckout(order['items'])">
          Buy Again
        </b-button>
        <b-button v-if="orderDetailInput" class="cp__order__btn no-outline-btn order-footer-btn" @click.stop="fetchOrderDetails(order)"
        :class="{'btn-outline-success btn-hover-theme': !isCustomerPortalOrderList}">
          View Details
        </b-button>
      </template>
    </b-card-footer>
    <OrderTransactions v-if="showTransactions" :order="order" @clear="toggleTransactionDialog()" />
    <TrackingSidebar v-if="selectedItem && showShipments" :item="selectedItem" @clear="toggleShipments(null)" />
    <OrderCheckout
      v-if="showCheckout"
      :items="selectedItems"
      :currency="order.currency"
      :is-subscription="isSubscription"
      :skip-initial="skipInitial"
      @clear="toggleCheckout()">
    </OrderCheckout>
  </b-card>
</template>

<script>
import {mapGetters, mapState} from 'vuex'
import {
  getItemFulfillmentStatus, getItemFulfillmentStatusClass, getItemImageUrl, getItemStatus,
  getItemStatusClass, getPaymentStatus, getPaymentStatusClass, getShortHumanReadableDate,
  getShortHumanReadableUTCDate, isRecurring, setFallbackImageUrl, setOrderDetail, showFulfillment,
  getItemIntents, isItemSelectionInput, getIntentLabel
} from '@/utils'
import {BillingCycleType, InputType, ItemStatus} from '@/constants'
const OrderCheckout = () => import('@/components/Order/OrderCheckout')
const OrderTransactions = () => import('@/components/Order/OrderTransactions')
const TrackingSidebar = () => import('@/components/Sidebar/TrackingSidebar')

export default {
  name: 'OrderTile',
  components: {OrderTransactions, TrackingSidebar, OrderCheckout},
  props: {
    order: Object,
    inputs: Array,
    orderAgain: Boolean,
    isOrderDetail: Boolean
  },
  data: function() {
    return {
      getShortHumanReadableDate,
      getShortHumanReadableUTCDate,
      paymentInfo: null,
      showShipments: false,
      showTransactions: false,
      showHeaderDropdown: false,
      showCheckout: false,
      selectedItems: [],
      isSubscription: false,
      skipInitial: false,
      showOrderSummary: false,
      selectedItem: null
    }
  },
  computed: {
    ...mapState(['session', 'campaign']),
    ...mapGetters(['canLogoutSession', 'isSessionUserKnown', 'checkoutDisabled', 'subscriptionStatusLabels']),
    validInputs: function() {
      return this.inputs || this.session.valid_inputs || []
    },
    additionalInputs: function() {
      return (this.session && this.session.additional_inputs) || []
    },
    enableColumnLayout: function() {
      return this.isOrderDetail || this.isCustomerPortalOrderHistory
    },
    isCustomerPortalOrderList: function() {
      return this.session && this.session['step_type'] === InputType.CustomerPortalOrders
    },
    isCustomerPortalOrderHistory: function() {
      return this.session && this.session['step_type'] === InputType.CustomerPortalOrderHistory
    },
    showHeader: function() {
      return this.isCustomerPortalOrderList || this.enableColumnLayout
    },
    hasShippingFee: function() {
      return this.order && this.order.shipping_price > 0
    },
    canShowOrderSummary: function() {
      return this.session && this.session.show_order_summary
    },
    showFooter: function() {
      return this.orderAgain || this.orderDetailInput || (this.isOrderDetail && this.canShowOrderSummary)
    },
    showTip: function() {
      return this.order && parseFloat(this.order.tip) > Number.EPSILON
    },
    showRefund: function() {
      return this.order && parseFloat(this.order.settled_refund_amount) > Number.EPSILON
    },
    showVoid: function() {
      return this.order && parseFloat(this.order.amount_voided) > Number.EPSILON
    },
    showPendingRefund: function() {
      return this.order && parseFloat(this.order.pending_refund_amount) > Number.EPSILON
    },
    showChargeback: function() {
      return this.order && parseFloat(this.order.chargeback_amount) > Number.EPSILON
    },
    showStoreCredit: function() {
      return this.order && parseFloat(this.order.store_credit) > Number.EPSILON
    },
    showStoreDebit: function() {
      return this.order && parseFloat(this.order.store_debit) > Number.EPSILON
    },
    showAmountDue: function() {
      return this.order && parseFloat(this.order.amount_due) > Number.EPSILON
    },
    showDiscount: function() {
      return this.order && parseFloat(this.order.discount) > Number.EPSILON
    },
    showHiddenFees: function() {
      return this.order && parseFloat(this.order.hidden_fees) > Number.EPSILON
    },
    showForwardBalance: function() {
      return this.order && parseFloat(this.order.forward_balance) > Number.EPSILON
    },
    showPastBalance: function() {
      return this.order && parseFloat(this.order.past_balance) > Number.EPSILON
    },
    orderDetailInput: function() {
      return this.validInputs.find((input) => input.type === InputType.CustomerPortalOrderDetail) ||
        this.additionalInputs.find((input) => input.type === InputType.CustomerPortalOrderDetail)
    },
    canShowTrackShipment: function() {
      let showTracking = false
      if (!this.isCustomerPortalOrderHistory && this.campaign.portal_settings) {
        if (this.isCustomerPortalOrderList) {
          showTracking = this.campaign.portal_settings.show_tracking_in_list
        } else if (this.isOrderDetail) {
          showTracking = this.campaign.portal_settings.show_tracking_in_details
        }
      }
      return showTracking && this.order && this.order.items.some((item) => item.is_shippable && item.can_track_shipment)
    },
    canShowTransactions: function() {
      let showTransactions = false
      if (this.campaign.portal_settings) {
        if (this.isCustomerPortalOrderList) {
          showTransactions = this.campaign.portal_settings.show_transactions_in_list
        } else if (this.isOrderDetail) {
          showTransactions = this.campaign.portal_settings.show_transactions_in_details
        }
      }
      return showTransactions && this.order && this.order.items.some((item) => item.show_transactions)
    },
    canShowPaymentStatus: function() {
      let showPaymentStatus = false
      if (this.campaign.portal_settings) {
        if (this.isCustomerPortalOrderList || this.isCustomerPortalOrderHistory) {
          showPaymentStatus = this.campaign.portal_settings.show_payment_status_in_list
        } else if (this.isOrderDetail) {
          showPaymentStatus = this.campaign.portal_settings.show_payment_status_in_details
        }
      }
      return showPaymentStatus
    },
    canShowPrice: function() {
      let showPrice = false
      if (this.campaign.portal_settings) {
        if (this.isCustomerPortalOrderList) {
          showPrice = this.campaign.portal_settings.show_price_in_list
        } else if (this.isOrderDetail) {
          showPrice = this.campaign.portal_settings.show_price_in_details
        }
      }
      return showPrice
    },
    canShowNextBillDate: function() {
      return this.campaign.portal_settings && this.campaign.portal_settings.show_next_bill_date
    },
    canShowFulfillmentStatus: function() {
      return this.campaign.portal_settings && this.campaign.portal_settings.show_fulfillment_status
    },
    canShowSubscriptionStatus: function() {
      return this.campaign.portal_settings && this.campaign.portal_settings.show_subscription_status
    },
    canShowShippingPrice: function() {
      return this.campaign.portal_settings && this.campaign.portal_settings.show_shipping_price
    },
    canShowTaxes: function() {
      return this.campaign.portal_settings && this.campaign.portal_settings.show_taxes
    },
    canShowToggleSummary: function() {
      return this.showDiscount || this.showHiddenFees || this.showTip || this.showPastBalance || this.showForwardBalance ||
        this.showVoid || this.showRefund || this.showChargeback || this.showPendingRefund || this.showAmountDue
    }
  },
  methods: {
    selectItemInput: function(item, intent) {
      let input = this.additionalInputs.find((input) => isItemSelectionInput(input))
      input && this.$emit('selectInput', {item, input, intent})
    },
    getIntentLabel: function(item, intent) {
      return getIntentLabel(item, intent)
    },
    toggleOrderSummary: function() {
      this.showOrderSummary = !this.showOrderSummary
    },
    toggleCheckout: function(items, isSubscription = false, skipInitial = false) {
      this.showCheckout = !this.showCheckout
      this.selectedItems = items || []
      this.isSubscription = isSubscription
      this.skipInitial = skipInitial
    },
    getItemFulfillmentStatus: function(item) {
      return getItemFulfillmentStatus(item)
    },
    getItemFulfillmentStatusClass: function(item) {
      return getItemFulfillmentStatusClass(item)
    },
    showFulfillment: function(item) {
      return this.isOrderDetail && this.canShowFulfillmentStatus && showFulfillment(item)
    },
    isTrial: function(item) {
      return item.status === ItemStatus.Trial
    },
    isSubscriptionActive: function(item) {
      return item && (item.billing_cycle_type === BillingCycleType.Recurring) && item.can_cancel_subscription
    },
    isSubscriptionPauseScheduled: function(item) {
      return this.isSubscriptionActive(item) && (item.status !== ItemStatus.Paused) && item.pause_resume_date
    },
    isSubscriptionCancelScheduled: function(item) {
      return item.cancel_date
    },
    getItemImageUrl: function(item) {
      return getItemImageUrl(item, 'large')
    },
    isRecurring: function(item) {
      return isRecurring(item)
    },
    setAltImg: function(event, item) {
      if (event) {
        setFallbackImageUrl(event, item, 'large', true)
      }
    },
    getPaymentStatus: function(order) {
      return getPaymentStatus(order, false)
    },
    getPaymentStatusClass: function(order) {
      return getPaymentStatusClass(order, false)
    },
    isItemStatusActive: function(item) {
      return item.status === ItemStatus.Active
    },
    getItemStatus: function(item) {
      return getItemStatus(item, this.subscriptionStatusLabels, false)
    },
    getItemStatusClass: function(item) {
      return this.orderAgain ? 'd-none' : getItemStatusClass(item)
    },
    fetchOrderDetails: function(order) {
      let input = this.orderDetailInput
      if (input) {
        let parent = this.$parent
        while (parent) {
          if (!parent['submitInput']) {
            parent = parent.$parent
          } else {
            setOrderDetail(order.id.toString())
            parent.submitInput(input)
            parent = null
          }
        }
      }
    },
    toggleTransactionDialog: function() {
      this.showTransactions = !this.showTransactions
    },
    toggleShipments: function(item) {
      this.selectedItem = item
      this.showShipments = !this.showShipments
    },
    onClickOutside: function() {
      this.showHeaderDropdown = false
      this.order['items'] = this.order['items'].map((item) => {
        item.showActions = false
        return item
      })
    },
    toggleItemActionsDropdown: function(index) {
      if (this.order['items'][index]) {
        this.order['items'][index].showActions = !this.order['items'][index].showActions
        this.order['items'] = [...this.order['items']]
      }
    },
    canReactivateSubscription: function(item) {
      return this.campaign.portal_settings && this.campaign.portal_settings.allow_reactivate_subscription && item.can_reactivate_subscription
    },
    canBuyAgain: function(item) {
      return this.campaign.portal_settings && this.campaign.portal_settings.allow_buy_again && item.can_charge_customer
    }
  },
  created() {
    if (this.order && this.order.items && this.order.items.length) {
      if (this.isOrderDetail) {
        const settings = this.campaign.portal_settings || {}
        const sessionIntents = new Set(this.session ? this.session.intents : [])
        this.order.items = this.order.items.map((item) => {
          const intents = getItemIntents(item, settings, false).filter(intent => sessionIntents.has(intent))
          if (intents.length === 0) {
            intents.push(InputType.ItemStatus) // show item status if there's no other intents
          }
          item['actions'] = intents
          return item
        })
      }
    }
  }
}
</script>

<style scoped>

</style>
